import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=a931f60c&scoped=true"
import script from "./CButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CButton.vue?vue&type=style&index=0&id=a931f60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a931f60c",
  null
  
)

export default component.exports